











import { Vue, Component, Prop } from "vue-property-decorator";

export type InputType =
  | "text"
  | "search"
  | "tel"
  | "url"
  | "email"
  | "password"
  | "date";

type InputSize = "default" | "wide";

@Component
export default class TextInput extends Vue {
  @Prop({ type: String, required: false, default: "" }) value!: string;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;
  @Prop({ type: String, required: false, default: "text" }) type!: InputType;
  @Prop({ type: String, required: false, default: "default" }) size!: InputSize;

  get classes(): (string | { [k: string]: boolean })[] {
    const result = [];

    // size
    switch (this.size) {
      case "default":
        break;
      case "wide":
        result.push("w-full");
    }

    return result;
  }
}
